import React, { useEffect, useState } from 'react';
import orderconfirmationStyle from './OrderConfirmationPage.module.css'
import mainLogo from '../../../assets/images/logo-new-green.webp'
import BackBar from '../../components/BackBar/BackBar';
import 'font-awesome/css/font-awesome.min.css';
import { BsPrinterFill } from "react-icons/bs";
import { useParams } from 'react-router-dom';

export default function OrderConfirmationPage() {
  const { order_number } = useParams();
  const [orderData, setOrderData] = useState(null);
  const [orderDataItem, setOrderDataItem] = useState(null);
  const order = orderData?.[0];

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_all_orders.php?order_number=${order_number}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setOrderData(data.order);
          setOrderDataItem(data.order_items);
        }
      });
  }, [order_number]);

  return (
    <>
      <div className={orderconfirmationStyle.orderconmain} style={{ minHeight: '700px' }}>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className='row justify-content-center'>
            <div className="col-lg-12">
              <div className={orderconfirmationStyle.orderconmainBody}>
                <div className={orderconfirmationStyle.orderconhead}>
                  <div className="row">
                    <div className="col-xl-6">
                      <img src={mainLogo} className={`${orderconfirmationStyle.imglogo}`} />
                    </div>
                    <div className="col-xl-6">
                      <div className={`${orderconfirmationStyle.orderheadtitles} text-end`}>
                        <h4>Order Confirmation</h4>
                        <p>Author Book Signing</p>
                        <p>Order ID: {order?.order_number}</p>
                        <p>School Name: {order?.school_name}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={orderconfirmationStyle.ordershipbox}>
                  <div className="row">
                    <div className="col-xl-6">
                      <div className={`${orderconfirmationStyle.ordershipboxleft} text-start`}>
                        <h4>Date: {order?.order_date ? new Date(order.order_date).toLocaleDateString('en-US', {
                          month: 'short', day: 'numeric', year: 'numeric'
                        }) : ''}</h4>
                        <h5>Parents Information:</h5>
                        <p>{order?.first_name} {order?.last_name}</p>
                        <p>{order?.email}</p>
                        <p>{order?.phone}</p>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className={`${orderconfirmationStyle.ordershipboxright} text-end`}>
                        <h4>Shipping Address </h4>
                        <p>Books are shipped to your school.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={orderconfirmationStyle.ordertblbox}>
                  <div className="row">
                    <div className="col-xl-12">
                      <h6>Order List:</h6>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="table-responsive">
                        <table className={`${orderconfirmationStyle.orderconfirmTable} table`}>
                          <tbody>
                            {orderDataItem?.map((item, index) => (
                              <tr key={index}>
                                <td className='w-50'>
                                  <div>{item.title}</div>
                                  <div>ISBN: {item.isbn}</div>
                                </td>
                                <td className='w-25 text-end' valign='middle'>Qty {item.quantity}</td>
                                <td className='w-25 text-end' valign='middle'>${item.price}</td>
                              </tr>
                            ))}

                            <tr>
                              <td className='w-50'></td>
                              <td className='w-25 text-end' valign='middle'><b>Total</b></td>
                              <td className='w-25 text-end' valign='middle'>${order?.total_amount}</td>
                            </tr>
                            <tr>
                              <td className='w-50'></td>
                              <td className='w-25 text-end' valign='middle'><b>Tax</b></td>
                              <td className='w-25 text-end' valign='middle'>${order?.tax}</td>
                            </tr>
                            <tr>
                              <td className='w-50'></td>
                              <td className='w-25 text-end' valign='middle'><b>Grand Total</b></td>
                              <td className='w-25 text-end' valign='middle'>${order?.total_amount}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={orderconfirmationStyle.orderfooterbox}>
                  <div className="row">
                    <div className="col-xl-12 text-center">
                      <h6>Bookworm Central | 12193 Livingston Road Manassas, VA 20109 | Email: info@bookwormcentral.com</h6>
                      <h5>Love books? Follow us:</h5>
                    </div>
                    <div className='col-xl-12 text-center'>
                      <div className={orderconfirmationStyle.socialbar}>
                        <a href="https://www.facebook.com/bookwormcentral" target="_blank" className={orderconfirmationStyle.fb}>
                          <i className='fa fa-facebook-f'></i>
                        </a>
                        <a href="https://www.instagram.com/bookwormcentral/" target="_blank" className={orderconfirmationStyle.ig}>
                          <i className="fa fa-instagram"></i>
                        </a>
                        <a href="https://www.linkedin.com/company/bookworm-central" target="_blank" className={orderconfirmationStyle.in}>
                          <i class="fa fa-linkedin"></i>
                        </a>
                        <a href="https://twitter.com/BookwormCentral" target="_blank" className={orderconfirmationStyle.tw}>
                          <i className="fa fa-twitter"></i>
                        </a>
                        <a href="https://pinterest.com/bookwormcentral/_created/" target="_blank" className={orderconfirmationStyle.pt}>
                          <i className="fa fa-pinterest-p"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
